// DS: PO24
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../Input';
import BaseConfirmationPopup from '../BaseConfirmationModal';
export var PromptModal = function (_a) {
    var _b = _a.initialInputValue, initialInputValue = _b === void 0 ? '' : _b, isOpen = _a.isOpen, title = _a.title, inputLabel = _a.inputLabel, doneButtonLabel = _a.doneButtonLabel, inputWrapperClassName = _a.inputWrapperClassName, extrasBeforeInput = _a.extrasBeforeInput, maxLength = _a.maxLength, minLength = _a.minLength, confirmDisabled = _a.confirmDisabled, onInputValidate = _a.onInputValidate, onCancel = _a.onCancel, onDone = _a.onDone;
    var t = useTranslation().t;
    var _c = useState(initialInputValue), inputValue = _c[0], setInputValue = _c[1];
    var errorHint = inputValue !== initialInputValue && onInputValidate
        ? onInputValidate(inputValue)
        : undefined;
    var updateInputValue = function (value) { return setInputValue(value); };
    var onDoneHandler = function () { return onDone && onDone(inputValue); };
    return (React.createElement(BaseConfirmationPopup, { isOpen: isOpen, title: title, confirmDisabled: !!errorHint ||
            confirmDisabled ||
            (minLength ? inputValue.length < minLength : false), confirmButtonLabel: doneButtonLabel || t('popup.done'), onCancel: onCancel, onDone: onDoneHandler },
        extrasBeforeInput,
        React.createElement("div", { className: inputWrapperClassName },
            React.createElement(Input, { autoFocus: true, value: inputValue, label: inputLabel, errorMessage: errorHint, onChange: updateInputValue, onEnter: !errorHint ? onDoneHandler : undefined, maxLength: maxLength }))));
};
PromptModal.displayName = 'PromptModal';
export default PromptModal;
//# sourceMappingURL=PromptModal.js.map